// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1WFof","title":"AfterBackImages_title__XqcvL","images":"AfterBackImages_images__1cwmZ"};